import "../components/FinancialSuperAdmin/wallet.scss";
import ManagementSidebar from "components/common/ManagementSidebar";
import Statistics from "../components/statistics/Statistics";
import WalletCard from "components/FinancialSuperAdmin/WalletCard";
import { useState, useEffect } from "react";
import { connection } from "utils/apiConnection.ts";
import UnblockWallet from "components/FinancialSuperAdmin/UnblockWalletCardModal";
import l1 from "assets/images/l1 (4).svg";
import l3 from "assets/images/l1 (2).svg";
import l2 from "assets/images/l1 (3).svg";
import l4 from "assets/images/l1 (1).svg";
import axios from "axios";
import toast from "react-hot-toast";

export default function WalletList() {
  const [isLoading, setIsLoading] = useState(false);
  const [updater, setUpdater] = useState(false);
  const [selectedItem, setSelectedItem] = useState(1);
  const [WalletCardData, setWalletCardData] = useState([
    // {
    //   fullName: "شمین فاضلی",
    //   date: "",
    //   inventory: "10000",
    //   input: "2000",
    //   output: "20",
    //   type: "1",
    // },
    // {
    //   fullName: "",
    //   date: "",
    //   inventory: "",
    //   input: "",
    //   output: "",
    //   type: "0",
    // },
  ]);
  useEffect(() => {
    connection("superadminapi/get_wallets").then((data) => {
      setWalletCardData(data.data.wallets);
    });
  }, [updater]);

  console.log("wallet", WalletCardData);

  // مسدود کردن ولت api
  const stopHandler = (id, uid) => {
    setIsLoading(true);
    let myFormData = new FormData();
    myFormData.append("keyvalues", `main_status,1`);
    myFormData.append(
      "conditions",
      `id/=/${id}@@uid/=/${uid}@@main_status/=/${0}`
    );
    axios
      .post(`http://old-sabadib.tatdemo.ir/api/Update_Wallets`, myFormData)
      .then((res) => {
        if (res.data.status == 1) {
          toast.success("  ولت با موفقیت متوقف شد");
          setIsLoading(false);
          setUpdater(!updater);
        } else {
          toast.error("  خطا در متوقف کردن  ولت!");
          setIsLoading(false);
        }
      });
  };

  // api فعال کردن ولت
  const unblockHandler = (id, uid) => {
    setIsLoading(true);
    let myFormData = new FormData();
    myFormData.append("keyvalues", `main_status,0`);
    myFormData.append(
      "conditions",
      `id/=/${id}@@uid/=/${uid}@@main_status/=/${1}`
    );
    axios
      .post(`http://old-sabadib.tatdemo.ir/api/Update_Wallets`, myFormData)
      .then((res) => {
        if (res.data.status == 1) {
          toast.success("  ولت با موفقیت فعال شد");
          setIsLoading(false);
          setUpdater(!updater);
        } else {
          toast.error("  خطا در فعال کردن ولت!");
          setIsLoading(false);
        }
      });
  };
  return (
    <>
      <div className=" w-100 mt-2 d-flex  " id="wallet-list">
        {/* <ManagementSidebar /> */}
        <div className="container">
          {/* report Cards */}
          <div className="d-flex flex-wrap">
            <div className=" col-12 col-sm-6 col-lg-3 ">
              <Statistics
                title="تعداد کل تامین کنندگان"
                type={1}
                txt="تامین کننده"
                number={145}
                icon={l1}
              />
            </div>
            <div className=" col-12 col-sm-6 col-lg-3 ">
              <Statistics
                title="تعداد تامین کنندگان فعال"
                type={2}
                txt="تامین کنند فعال"
                number={145}
                icon={l2}
              />
            </div>
            <div className=" col-12 col-sm-6 col-lg-3 ">
              <Statistics
                title="تعداد سوپر مارکت ها"
                type={3}
                txt="سوپرمارکت"
                number={145}
                icon={l3}
              />
            </div>
            <div className=" col-12 col-sm-6 col-lg-3 ">
              <Statistics
                title="تعداد پروتئینی ها"
                type={4}
                txt="پروتئینی"
                number={145}
                icon={l4}
              />
            </div>
          </div>
          <WalletCard
            WalletCardData={WalletCardData}
            stopHandler={stopHandler}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
            unblockHandler={unblockHandler}
          />
        </div>
      </div>
    </>
  );
}
